<template>
<ClientOnly>
    <div class="cookie-consent-gate">
        <div class="overlay" />
        <div class="accept">
            <div class="accept-inner">
                <div tabindex="0" :class="ConsentUpdateClass">
                    {{ $t('COOKIE.CONSENT_PROMPT') }}
                </div>
            </div>
        </div>
    </div>
</ClientOnly>
</template>

<script setup lang="ts">
import { CookieYes } from '$services/cookieyes'

const ConsentUpdateClass = CookieYes.ConsentUpdateClass
</script>

<style scoped lang="scss">
.cookie-consent-gate {
    z-index: 10;
    position: relative;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(5px);

    .overlay {
        z-index: 11;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--neutral-900);
        opacity: 0.5;
    }
    .accept {
        z-index: 11;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 1.1em;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--neutral-50);
        .accept-inner {
            cursor: pointer;
            background-color: black;
            padding: 10px 16px;
            a {
                color: var(--neutral-50);
            }
        }
    }
}
</style>
